import moment from 'moment'

export default class File {
  constructor(data) { // response.data
    if (!data) {
      this.id = null;
      this.name = null;
      this.origin = null;
      this.extension = null;
      this.creationDate = null;
      this.updateDate = null;
      this.ownerId = null;
      this.version = 0;
      this.read = false;
    } else {
      this.id = data.id;
      this.name = data.name.normalize(); // Fixes font errors on certain browsers
      this.origin = data.origin;
      this.extension = data.extension;
      this.creationDate = moment(data.creationDate).toDate();
      this.updateDate =  moment(data.updateDate).toDate();
      this.ownerId = data.ownerId;
      this.version = data.version;
      this.read = data.read;
    }
  }

  static get Origins() {
    return {mine: 'CLIENT', shared: 'LOREAL'};
  }

  get displayName() {
    return this.name + "." + this.extension;
  }
}



// WEBPACK FOOTER //
// ./src/models/File.js